import { render, staticRenderFns } from "./GoodsOdyList.vue?vue&type=template&id=3c046f80&"
import script from "./GoodsOdyList.vue?vue&type=script&lang=js&"
export * from "./GoodsOdyList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsOdyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GoodsOdyItem: require('/home/runner/work/myody_front/myody_front/components/goods/GoodsOdyItem.vue').default})
